<template>
  <v-dialog v-model="showDialog" width="500">
    <v-card v-if="item && row">
      <v-card-title>
        <div class="title">Add / Remove Tags</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div class="pa-2 my-1">
        <v-chip
          x-small
          class="mr-1"
          v-for="t in rowTags"
          :key="t"
          @click="handleRemoveTag(t)"
        >
          {{ t }}
        </v-chip>
      </div>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="8">
            <v-text-field
              :label="$lang('tag') + ' ' + $lang('TITLE')"
              :hint="$lang('TITLE-HINT')"
              v-model="item.title"
              clearable
              :error-messages="errors && errors.title ? errors.title : []"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn class="mt-4" block outlined @click="doSubmit">{{
              $lang("CREATE")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text style="max-height: 400px; overflow: scroll">
        <v-chip
          @click.stop="attachExisting(itm)"
          small
          :style="'background:' + getRandomColorLuminance() + '; color: white'"
          class="ma-1"
          v-for="itm in filteredItems"
          :key="itm.id"
        >
          {{ itm.title }}
        </v-chip>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getRandomColorLuminance } from "@/helpers/utils";

export default {
  name: "new-tags-dialog",
  props: ["show", "tags", "row"],
  emits: ["opened", "created"],
  components: {},
  data() {
    return {
      item: {
        id: null,
        title: "",
      },
      filteredItems: [],
      showDialog: null,
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth/auth",
    }),
    errors: {
      get() {
        return this.$store.getters.getFormErrors;
      },
      set(_) {},
    },

    rowTags() {
      let rowTags = this.row.tags.split(",").map((el) => el.trim());
      return rowTags;
    },
  },
  watch: {
    "item.title"(val) {
      this.filterItems();
    },
    tags(tags) {
      this.filterItems();
      this.item = {};
    },
    show(val) {
      this.showDialog = val;
      this.item = {};
    },
    showDialog(val) {
      this.$emit("opened", val);
    },
  },
  methods: {
    getRandomColorLuminance() {
      return getRandomColorLuminance(-0.6);
    },
    tagExists() {
      let title = this.item.title;
      return this.tags.filter((el) => {
        return el.title.toLowerCase() == title.toLowerCase();
      })[0];
    },
    attachExisting(tag) {
      this.$emit("created", tag);
      this.addToRow(tag);
      this.item = {};
    },
    handleRemoveTag(t) {
      this.row.modified = true;
      let rowTags = this.row.tags.split(",").map((el) => el.trim());
      rowTags = rowTags.filter((el) => el.toLowerCase() != t.toLowerCase());
      rowTags = rowTags.filter((el) => el.trim());
      this.row.tags = rowTags.join(",");
    },
    handleAddTag(t) {
      this.row.modified = true;
      let rowTags = this.row.tags.split(",").map((el) => el.trim());
      if (!rowTags.find((e) => e.toLowerCase() == t.toLowerCase())) {
        rowTags.push(t);
      }
      rowTags = rowTags.filter((el) => el.trim());

      this.row.tags = rowTags.join(",");
    },
    addToRow(tag) {
      this.row.modified = true;
      let rowTags = this.row.tags.split(",").map((el) => el.trim());

      if (rowTags.find((e) => e.toLowerCase() == tag.title.toLowerCase())) {
        rowTags = rowTags.filter(
          (el) => el.toLowerCase() != tag.title.toLowerCase()
        );
      } else {
        rowTags.push(tag.title);
      }
      rowTags = rowTags.filter((el) => el.trim());
      this.row.tags = rowTags.join(",");
    },
    filterItems() {
      let val =
        this.item && this.item.title ? this.item.title.toLowerCase() : "";
      this.filteredItems = this.tags.filter((el) => {
        return el.title.toLowerCase().includes(val);
      });
    },
    doSubmit() {
      let existing = this.tagExists();
      if (existing) {
        this.$emit("created", existing);
        this.addToRow(existing);
        this.item = {};
        // this.showDialog = false;
        return Promise.resolve("ADDED_EXISTING");
      }
      // attach ident to tags
      this.item.ident = "questions";
      return this.$store
        .dispatch("dashboard/prep/TagsCreate", {
          item: this.item,
          context: this,
        })
        .then((tag) => {
          this.$emit("created", tag);
          this.addToRow(tag);
          // this.showDialog = false;
        });
    },
  },
  created() {
    this.showDialog = this.show;
  },
};
</script>
